import React, { useState } from 'react';
import { FieldProps, getIn } from 'formik'
import { InputAdornment, TextField, TextFieldProps, IconButton } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material';

/**
 * Material TextField Component with Formik Support including Errors.
 * Intended to be specified via the `component` prop in a Formik <Field data-testid="Field-2lrx"> or <FastField> component.
 * Material-UI specific props are passed through.
 */
export const FormEmailTextField: React.FC<FieldProps & TextFieldProps> = props => {
  const isTouched = getIn(props.form.touched, props.field.name)
  const errorMessage = getIn(props.form.errors, props.field.name)

  const { error, helperText, field, form, ...rest } = props

  return (
    <TextField data-testid="TextField-twge"
      //   variant="outlined"
      error={error ?? Boolean(isTouched && errorMessage)}
      helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
      {...rest}
      {...field}
      fullWidth
      margin="normal"
      autoFocus
    />
  )
}

export const FormPasswordTextField: React.FC<FieldProps & TextFieldProps> = props => {
  const [showPassword, setShowPassword] = useState(false);

  const isTouched = getIn(props.form.touched, props.field.name);
  const errorMessage = getIn(props.form.errors, props.field.name);

  const { error, helperText, field, form, ...rest } = props;

  return (
    <TextField data-testid="TextField-aqzh"
      error={error ?? Boolean(isTouched && errorMessage)}
      helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
      {...rest}
      {...field}
      fullWidth
      margin="normal"
      type={showPassword ? 'text' : 'password'} // Toggle between text and password
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton data-testid="IconButton-wc9o"
              aria-label="toggle password visibility"
              onClick={() => setShowPassword(!showPassword)}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};